import { forwardRef } from "react";

export const TextInput = ({
  type,
  name,
  placeholder,
  register,
  label,
  defaultValue,
  handleChange,
}) => {
  return (
    <>
      {register ? (
        <input
          defaultValue={defaultValue && defaultValue}
          type={type ? type : "text"}
          name={name}
          placeholder={placeholder}
          {...register(label)}
        />
      ) : (
        <input
          defaultValue={defaultValue && defaultValue}
          type={type ? type : "text"}
          name={name}
          placeholder={placeholder}
          onChange={handleChange}
        />
      )}
    </>
  );
};
